export default {"src":"/_next/static/media/step-3.c81a063c.svg","height":24,"width":17};